import { createStyles, makeStyles, Theme, createTheme } from '@material-ui/core/styles';

const defaultTheme = createTheme({});
const { pxToRem } = defaultTheme.typography;


export const TableUseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '5px',
      minWidth: '100px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '0px',
      height: '10px',
    },
    //収集失敗
    bodyCellError: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '5px',
      minWidth: '100px',
      color: '#ff0000',
    },
    //収集中
    bodyCellRun: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '5px',
      minWidth: '100px',
      color: '#00008b',
    },
    //収集完了
    bodyCellEnd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '5px',
      minWidth: '100px',
      color: '#006400',
    },
    bodyRow: {

      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: '#7fffd4',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },
    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '100%',
      border: 'none',
      backgroundColor: 'transparent',
      textAlign: "center",
    },
  })
);


export const IoTDevListStyle = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 274px)',
    },
    //画面ヘッダ部ペーパ＾
    paperRoot: {
      maxWidth: '1100px',
      minWidth: '1100px',
      padding: '3px',
    },
    buttonRoot: {
      minWidth: '130px',
    },
    //画面ヘッダ部ラジオボタン
    muiTypography: {
      fontSize: pxToRem(14),
      lineHeight: 1.66,
    },
    //画面で使用しているチェックボックス
    checkBox: {
      padding: '0px',
    },
    spacingXs1: {
      minWidth: '1440px',
    },
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },

  })
);

export const FooterBaseStyle = makeStyles(
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);
